module.exports = __webpack_public_path__ + "static/media/rectangle-5.1ef531f3.svg";